export const TEMPORAL_CONNECTOR_PATTERN = /^(?:later|then|afterward|afterwards)\b[\s,:-]*/i;
export const CAUSAL_CONNECTOR_PATTERN = /^(?:so|because|in response to|as a result)\b[\s,:-]*/i;
export const INLINE_CAUSAL_SPLIT_PATTERNS = [
  /\bso\b/i,
  /\bbecause\b/i,
  /\bin response to\b/i,
  /\bas a result\b/i,
];

export const stripLeadingRelationshipConnector = (text = '') => String(text || '')
  .replace(TEMPORAL_CONNECTOR_PATTERN, '')
  .replace(CAUSAL_CONNECTOR_PATTERN, '')
  .replace(/^(?:and)\b[\s,:-]*/i, '')
  .trim()
  .replace(/^[,.\-:\s]+/u, '')
  .trim();

export const splitSentenceParts = (text = '') => String(text || '')
  .split(/(?<=[.!?])\s+(?=[A-Z0-9"“(])/u)
  .map((part) => String(part || '').trim())
  .filter(Boolean);

export const getLeadingRelationshipKind = (text = '') => {
  const comparable = String(text || '').trim();
  if (CAUSAL_CONNECTOR_PATTERN.test(comparable)) {
    return 'causal';
  }
  if (TEMPORAL_CONNECTOR_PATTERN.test(comparable)) {
    return 'temporal';
  }
  return 'none';
};

export const hasMultiDomainSentenceBoundary = (text = '') => {
  const comparable = String(text || '').trim();
  if (!comparable) {
    return false;
  }

  return INLINE_CAUSAL_SPLIT_PATTERNS.some((pattern) => pattern.test(comparable))
    || comparable.includes(',')
    || /\band\b/i.test(comparable)
    || /[.!?]/.test(comparable);
};

export const countWords = (text = '') => String(text || '')
  .trim()
  .split(/\s+/)
  .filter(Boolean)
  .length;

export const hasExplicitRelationshipSignal = (text = '') => {
  const comparable = String(text || '').trim();
  if (!comparable) {
    return false;
  }

  return TEMPORAL_CONNECTOR_PATTERN.test(comparable)
    || CAUSAL_CONNECTOR_PATTERN.test(comparable)
    || INLINE_CAUSAL_SPLIT_PATTERNS.some((pattern) => pattern.test(comparable));
};

export const ensureSentence = (text = '') => {
  const normalized = String(text || '').trim();
  if (!normalized) {
    return '';
  }
  return /[.!?]$/.test(normalized) ? normalized : `${normalized}.`;
};

export const toSentenceCase = (text = '') => {
  const normalized = String(text || '').trim();
  if (!normalized) {
    return '';
  }
  return `${normalized.charAt(0).toUpperCase()}${normalized.slice(1)}`;
};
